import { render, staticRenderFns } from "./payline-viewer.vue?vue&type=template&id=4c565781&"
import script from "./payline-viewer.vue?vue&type=script&lang=js&"
export * from "./payline-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports